import { reactive } from "vue";

export interface CubeStateInterface {
  inited: boolean;
  chartTypes: any[];
  dashboards: any[];
  reports: any[];
}

function state(): CubeStateInterface {
  return {
    inited: false,
    chartTypes: [],
    dashboards: [],
    reports: reactive([]),
  };
}

export default state;
